import axios from 'axios'
import {useEffect, useState, useCallback} from 'react'
import {BASE_URL} from '../modules/config'
import {ISelectOption} from '../utils/core/_model'

const useUserRole = () => {
  const [roles, setRoles] = useState<ISelectOption[]>([])

  const getUserType = useCallback(async () => {
    try {
      const response = await axios.get<{
        data: {
          id_level: number
          level_name: string
          created_by: number
        }[]
      }>(`${BASE_URL}/api/protect/getAllRole`)
      const data = await response.data
      const formatted = data.data.map((role) => ({
        id: role.id_level,
        value: role.level_name,
        label: role.level_name,
      }))
      setRoles(formatted || [])
    } catch (error) {
      console.log(error)
    }
  }, [])

  useEffect(() => {
    getUserType()
  }, [getUserType])

  return {roles, refetch: getUserType}
}

export default useUserRole
